import React from 'react';
import PropTypes from 'prop-types';

import activeBadge from '../../../assets/img/svg/referral/Active.svg';
import closedBadge from '../../../assets/img/svg/referral/Closed.svg';
import inactiveBadge from '../../../assets/img/svg/referral/Inactive.svg';
import nurtureBadge from '../../../assets/img/svg/referral/Nurture.svg';
import holdBadge from '../../../assets/img/svg/referral/Hold.svg';

const StatusBadge = ({ statusGroup }) => {
  switch (statusGroup) {
    case 'ACTIVE':
      return (<img className='badge-icon-image' src={activeBadge} />);
    case 'CLOSED':
      return (<img className='badge-icon-image' src={closedBadge} />);
    case 'FALLOUT':
      return (<img className='badge-icon-image' src={inactiveBadge} />);
    case 'NURTURE':
      return (<img className='badge-icon-image' src={nurtureBadge} />);
    case 'HOLD':
      return (<img className='badge-icon-image' src={holdBadge} />);
    default:
  }
  return null;
};

StatusBadge.propTypes = {
  statusGroup: PropTypes.string
};

export default StatusBadge;
